import { useUnit } from 'effector-react';
import { gameModel } from 'entities/game';
import { Button } from 'shared/ui';
import { betMenuModel } from '../../model';
import cls from './bet-menu-fast-bets.module.scss';

export const BetMenuFastBets = () => {
	const [disabled, fastBets, fastBet] = useUnit([
		betMenuModel.$betButtonDisabled,
		gameModel.$fastBets,
		betMenuModel.fastBetButtonClicked,
	]);

	return (
		fastBets.length > 0 && (
			<div className={cls.betMenuFastBets}>
				{fastBets.map((bet) => (
					<Button
						key={bet}
						fullWidth
						disabled={disabled}
						className={cls.betMenuFastBetsButton}
						onClick={() => {
							fastBet(bet);
						}}
					>
						{bet}
					</Button>
				))}
			</div>
		)
	);
};
